module.exports = __webpack_public_path__ + "img/Icon material-iso.34ace65d.svg";